import React, { ReactNode, createContext, useContext } from 'react';

export type ObjectListLayout = 'default' | 'admin';

const ObjectListLayoutContext = createContext<ObjectListLayout>('default');

interface ObjectListLayoutProviderProps {
    children: ReactNode;
    layout: ObjectListLayout;
}

export const ObjectListLayoutProvider = (props: ObjectListLayoutProviderProps) => {
    return <ObjectListLayoutContext.Provider value={props.layout}>{props.children}</ObjectListLayoutContext.Provider>;
};

export const useObjectListLayout = () => useContext(ObjectListLayoutContext);
